import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import logo from '../../../../assets/logo.svg';
import logo_white from '../../../../assets/logo-white.svg';
import './styles.scss';
import '../../styles.scss';
import CollapsedBox from '../../../../components/CollapsedBox';
import SupportCard from '../../../../components/SupportCard';
import contactInfo from '../../../WelcomePage/constants/contactInfo';
import { getErrorMessageFromUrlSearchParams } from '../../utils/getErrorMessageFromUrlSearchParams';
import { handleTrackingIdInSessionStorage } from '../../utils/handleTrackingIdInSessionStorage';

import { sendAuthErrorEmail } from '../../services/sendAuthErrorEmail';

const isDarkMode =
  window.matchMedia('(prefers-color-scheme: dark)').matches || window.matchMedia('(color-scheme: dark)').matches;

const Auth0ErrorPage = () => {
  const { t } = useTranslation('account');
  const errorMessageData = getErrorMessageFromUrlSearchParams(new URL(window.location));

  const displayErrorMessageData = {
    errorDescription: `(${errorMessageData.error}) ${errorMessageData.error_description}`,
    trackingId: errorMessageData.tracking,
  };

  useEffect(() => {
    const trackingId = handleTrackingIdInSessionStorage(errorMessageData);

    const checkIfErrorMessageDataAndIsNotSameError = errorMessageData && trackingId !== errorMessageData.tracking;

    if (checkIfErrorMessageDataAndIsNotSameError) {
      sendAuthErrorEmail(errorMessageData);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="auth0-wrapper">
      <img className="error-logo-image" src={isDarkMode ? logo_white : logo} alt="Feller" />
      <div className="auth0-main-content-wrapper">
        <h1 className="auth0-title">{t('auth0Error.title')}</h1>
        <p className="error-description">{t('auth0Error.description')}</p>
        <p className="error-description">{t('auth0Error.action')}</p>
        {errorMessageData && <CollapsedBox title="Details" displayErrorMessageData={displayErrorMessageData} />}
      </div>
      <div className="auth0-cards-wrapper">
        {contactInfo.map((contact, idx) => (
          <SupportCard key={idx} contact={contact} />
        ))}
      </div>
    </div>
  );
};

export default Auth0ErrorPage;
